module.exports = __webpack_public_path__ + "static/img/role.66161b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/mz/role.png
// module id = 9qGh
// module chunks = 7